
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as QuestionIconComponent } from "./question-icon.svg";

export const QuestionIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <QuestionIconComponent {...props} />;
};
